// Application Components
// import React, { useEffect } from 'react'
import React from 'react'
import { useSelector } from 'react-redux'

//// Application Slices
import { selectSettings } from '../../reducers/settingSlice'

//// Application Components
import ButtonComponent from '../../components/conditional-components/button-component'

//// Carbon Components
import { Form } from '@carbon/react'

//// Carbon Icons

//// Static Constants

//////// Component
const RegisteredNursingExaminationIntroductionForm = () => {
    //////// Hooks

    //////// State

    //////// Slices
    const settingsData = useSelector(selectSettings)

    //// Slice Data
    const submit_route = settingsData?.['form']?.['submit_route']

    //////// Search Params

    //////// Methods

    //////// Functional Methods

    //////// Memoization

    //////// Effects/Side Effects

    //////////////// Render & Return
    return (
        <>
            <Form tabIndex={0}>
                <p>
                    <strong>Nurse Licensure Compact (NLC):</strong> Florida is a
                    member of the NLC. The NLC allows an RN/LPN licensed in a
                    Compact state to practice across state lines in another
                    Compact state without having to obtain a license in that
                    state unless you declare the new Compact state as your new
                    primary state of residence. It is important to understand
                    that the NLC requires you to adhere to the nursing practice
                    laws & rules of the state in which you practice. If you move
                    to another state and establish residency, you must apply for
                    licensure in that state. Visit the NCSBN website for a list
                    of Compact states.
                </p>

                <p>
                    <strong>
                        Graduates from one of the following are eligible to
                        apply:
                    </strong>
                </p>

                <ul>
                    <li>
                        Florida approved nursing education programs as defined
                        in section (s.) 464.003, Florida Statutes.
                    </li>
                    <li>
                        ACEN/CCNE accredited nursing programs with an NCLEX
                        code.
                    </li>
                    <li>
                        Nursing education programs that have been approved or
                        recognized by the jurisdiction in which it is based and
                        that has been issued an NCLEX code.
                    </li>
                    <li>Military nursing programs with an NCLEX code.</li>
                    <li>
                        Generic Master of Science in Nursing (MSN) or higher
                        programs with an NCLEX code.
                    </li>
                    <li>
                        A non-NCSBN jurisdiction or international education
                        program that the board determines is equivalent to an
                        approved program.
                    </li>
                    <li>
                        Canadian RNs who took the Canadian Nurses Association
                        Testing Service (CNATS) Exam after August 8, 1995, must
                        take the NCLEX unless licensed in another U.S.
                        state/territory. If test scores are acceptable, Canadian
                        RN applicants who took the CNATS prior to August 8,
                        1995, may be eligible for endorsement.
                    </li>
                </ul>

                <p>
                    <strong>Important Information:</strong> In addition to
                    applying for licensure with the board you must register with
                    Pearson VUE (Pearson) and the board and pay the fee.{' '}
                    <strong>Fees paid to Pearson are nonrefundable</strong>.{' '}
                    View the NCLEX Candidate Bulletin and register with Pearson
                    online at{' '}
                    <a
                        href="https://www.nclex.com/"
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label="nclex-exam-link"
                        type="link"
                    >
                        https://www.nclex.com/
                    </a>{' '}
                    or by phone at 1-866-496-2539. Failure to register for the
                    exam with Pearson will delay the approval of your
                    Authorization to Test (ATT). Applicants should register with
                    Pearson prior to approval by the board, except for
                    applicants educated outside the U.S., who should wait for
                    board approval.
                </p>

                <p>
                    Any applicant who does not take their scheduled exam by the
                    end date of their ATT must re-register with Pearson and
                    notify the board office. The board is not able to grant
                    extensions.
                </p>

                <p>
                    The name listed on your application and provided to Pearson{' '}
                    <strong>
                        must match the first and last name on the identification
                    </strong>{' '}
                    that you intend to provide on the day of your examination.
                    When you arrive at the test center, you must present your
                    ATT and acceptable identification. Variances may cause you
                    to be turned away from your examination and required to
                    re-register and pay another examination fee and any
                    additional international scheduling fees. Find out more at{' '}
                    <a
                        href="https://www.nursecompact.com"
                        target="_blank"
                        rel="noreferrer noopener"
                        aria-label="logout-link"
                        type="link"
                    >
                        https://nursecompact.com/
                    </a>
                    . Email the board at mqa.nursingappstatus@flhealth.gov to
                    request your name be corrected if necessary.
                </p>

                <p>
                    <strong>Graduate Nurse (GN) Status:</strong> An applicant
                    approved for GN Status may practice nursing before passing
                    the NCLEX. See the {'"Education History"'} tab for further
                    details.
                </p>

                <div className="button-group">
                    <div className="button-group-item">
                        <ButtonComponent
                            link={submit_route}
                            title="Start Application"
                        />
                    </div>
                </div>
            </Form>
        </>
    )
}

export default RegisteredNursingExaminationIntroductionForm
